import { useCallback, useMemo, useState } from 'react';
import { useSideEffectListener } from '../useStreaming/useSideEffectListener';
const UNKNOWN_USER_MESSAGE_ID = 'unknown';
export const useConversationStatusMessage = _ref => {
  let {
    connection,
    conversationId
  } = _ref;
  const [statusEntries, setStatusEntries] = useState([]);
  const onConversationStatus = useCallback(payload => {
    if (payload.conversationId !== conversationId) {
      return;
    }
    setStatusEntries(prev => {
      const userMessageId = payload.userMessageId ?? UNKNOWN_USER_MESSAGE_ID;
      const idx = prev.findIndex(entry => entry.conversationId === payload.conversationId && entry.userMessageId === userMessageId);
      let nextMessages = [payload.statusMessage];
      if (payload.thinkingMode && idx !== -1) {
        const prevMessages = prev[idx].statusMessages;
        const last = prevMessages[prevMessages.length - 1];
        nextMessages = last === payload.statusMessage ? prevMessages : [...prevMessages, payload.statusMessage];
      }
      if (idx !== -1) {
        // Update existing entry
        const updated = [...prev];
        updated[idx] = {
          ...updated[idx],
          statusMessages: nextMessages
        };
        return updated;
      } else {
        // Add new entry
        return [...prev, {
          conversationId: payload.conversationId,
          userMessageId,
          statusMessages: nextMessages
        }];
      }
    });
  }, [conversationId]);
  useSideEffectListener({
    connection,
    onSideEffect: onConversationStatus,
    filter: {
      name: 'conversationStatus'
    }
  });
  const statusMessages = useMemo(() => Object.fromEntries(statusEntries.filter(entry => entry.conversationId === conversationId).map(entry => [entry.userMessageId, entry.statusMessages.length === 1 ? entry.statusMessages[0] : JSON.stringify(entry.statusMessages)])), [conversationId, statusEntries]);
  return {
    statusMessages,
    statusMessagesEntries: statusEntries
  };
};
//# sourceMappingURL=useConversationStatusMessage.js.map